import { render, staticRenderFns } from "./diy.vue?vue&type=template&id=724e871e&scoped=true&"
import script from "./diy.vue?vue&type=script&lang=js&"
export * from "./diy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e871e",
  null
  
)

export default component.exports